import { useBlockAttachments } from "components/Dashboard/DoctorDashboard/notes-and-forms/scenes/note-fill-in/contexts/BlockAttachmentsContext";
import { createContext, ReactNode, useContext } from "react";
import {
  BLOCK_TYPE_MODES,
  TBlockType,
} from "../../../../../constants/blockTypeModes";

type Context = {
  disabled: boolean;
  mode?: TBlockType;
  isEdit?: boolean;
  isFill?: boolean;
  isPrint?: boolean;
  isDownload?: boolean;
  value?: any;
  onChange?: (arg: any) => void;
  onUpload?: ReturnType<typeof useBlockAttachments>["onUpload"];
};

const BlockTypeContext = createContext<Context>({
  disabled: false,
  mode: BLOCK_TYPE_MODES.edit,
  onChange: undefined,
  onUpload: undefined,
});

export const BlockTypeContextProvider = ({
  disabled = false,
  mode,
  value,
  onChange,
  children,
}: Pick<Context, "mode" | "value" | "onChange"> & {
  /**
   * if it is disabled to make changes (e.g. change text, upload files)
   * @default false
   */
  disabled?: boolean;
  children?: ReactNode;
}) => {
  const { onUpload } = useBlockAttachments();
  return (
    <BlockTypeContext.Provider
      value={{
        disabled,
        mode,
        value,
        onChange: disabled ? undefined : onChange,
        onUpload: disabled ? undefined : onUpload,
        isEdit: mode === BLOCK_TYPE_MODES.edit,
        isFill: mode === BLOCK_TYPE_MODES.fill,
        isPrint: mode === BLOCK_TYPE_MODES.print,
        isDownload: mode === BLOCK_TYPE_MODES.download,
      }}
      children={children}
    />
  );
};

export const useBlockType = () => useContext(BlockTypeContext);
